import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { buildClassNames, buildClassNameModifiers } from '../util/utils';

import { renderableType } from '../proptypes/prop-types';
import { DefaultMegaMenuRenderer } from '../menu';
import './navbar.scss';

/** Block */
const blockClassName = 'navbar';
const containerClassName = 'navbar__container';
const menuListClassName = 'navbar__menuList';

/** A component for menu-style navigation */
export const Navbar = ({
                  className,
                  children,
                  appTitle,
                  fixed,
                  ...other
                }) => (
  <nav
    className={buildClassNames(
      className,
      buildClassNameModifiers(blockClassName, { fixed }),
      blockClassName,
    )}
    {...other}
  >
    <div className={containerClassName}>
      {appTitle}
      {children &&
        <ul role='menubar' className={menuListClassName}>
          {React.Children.map(children, (child) => {
            if (!child) return null;
            if (child.props && child.props.isMegaMenu) {
              return (
                <li>
                  {cloneElement(child, {
                    role: 'menuitem',
                    menuAlignment: child.props.renderer === DefaultMegaMenuRenderer
                      ? 'full'
                      : child.props.menuAlignment,
                    menuWidth: child.props.renderer === DefaultMegaMenuRenderer
                      ? undefined
                      : child.props.menuWidth,
                  })}
                </li>
              );
            }
            if (child.props && child.props.isNavItemGroup) {
              return child;
            }
            return <li>{child}</li>;
          })}
        </ul>
      }
    </div>
  </nav>
);

Navbar.propTypes = {
  /** @ignore */
  className: PropTypes.string,
  /** @ignore */
  children: renderableType,
  /** Content to be rendered as the application title */
  appTitle: renderableType,
  /** Determines whether the top nav should always remain in view */
  fixed: PropTypes.bool,
};
Navbar.defaultProps = { fixed: false };

